import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './views/login/login.component';
import { authGuard } from './services/auth/auth.guard';
import { RegisterComponent } from './views/register/register.component';
import { TechsureLmsComponent } from './views/techsure-lms/techsure-lms.component';
import { AssessmentsComponent } from './views/techsure-lms/assessments/assessments.component';
import { TechsureQueriesComponent } from './views/techsure-lms/techsure-queries/techsure-queries.component';
import { TakeAssessmentComponent } from './views/techsure-lms/take-assessment/take-assessment.component';
import { AssessmentSummaryComponent } from './views/techsure-lms/assessment-summary/assessment-summary.component';

const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' }, // Redirect root to Home
    { path: 'home', redirectTo: 'vigi/product-queries' },
    { path: 'login', component: LoginComponent},
    { path: 'register', component: RegisterComponent},
    {
      path: 'vigi',
      loadChildren: () =>
        import('./views/vigi/vigi.module').then((m) => m.VigiModule),
      canActivate: [authGuard]
    },
    { 
    path: 'techsure', 
    component: TechsureLmsComponent, 
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'assessments', pathMatch: 'full' },
      { path: 'assessments', component: AssessmentsComponent },
      { path: 'queries', component: TechsureQueriesComponent },
      { path: 'take/:key', component: TakeAssessmentComponent },
      { path: 'results/:id', component: AssessmentSummaryComponent }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
